<template>
  <d2-container>
    <template slot="header">
      <el-select
        v-model="listQuery.channelType"
        clearable
        placeholder="渠道类型"
        size="small"
        style="width: 140px; margin-right: 10px;"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="图片" value="image"></el-option>
        <el-option label="视频" value="video"></el-option>
        <el-option label="LLM" value="llm"></el-option>
      </el-select>
      <el-input
        v-model="listQuery.keyword"
        clearable
        size="small"
        placeholder="渠道ID/名称"
        style="width: 220px; margin-right: 10px;"
        @keyup.enter.native="getSearch"
      ></el-input>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getSearch"
      >搜索</el-button>
      <el-button
        type="success"
        size="small"
        icon="el-icon-refresh"
        @click="refreshCache"
      >刷新缓存</el-button>
      <el-button
        type="warning"
        size="small"
        icon="el-icon-setting"
        @click="openModelConfigDialog('model')"
      >模型与映射</el-button>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-circle-plus"
        @click="addCard"
      >新增渠道</el-button>
    </template>

    <el-table
      size="small"
      stripe
      border
      :data="displayList"
      v-loading="listLoading"
    >
      <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
      <el-table-column prop="channelId" label="渠道ID" width="140" align="center"></el-table-column>
      <el-table-column prop="channelName" label="渠道名称" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column prop="channelType" label="类型" width="90" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="getChannelTypeTag(scope.row.channelType)">
            {{ getChannelTypeLabel(scope.row.channelType) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="provider" label="服务商" width="120" align="center"></el-table-column>
      <el-table-column label="支持模型" min-width="260" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ formatSupportedModels(scope.row.supportedModels) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="weight" label="权重" width="80" align="center"></el-table-column>
      <el-table-column prop="priority" label="优先级" width="90" align="center"></el-table-column>
      <el-table-column label="启用" width="90" align="center">
        <template slot-scope="scope">
          <el-switch
            :value="!!scope.row.enabled"
            @change="toggleEnabled(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="170" align="center"></el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="editCard(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogStatus" :visible.sync="dialogFormVisible" width="720px">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="渠道ID" prop="channelId">
              <el-input v-model="form.channelId" :disabled="!!form.id" placeholder="如 primary"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="渠道名称" prop="channelName">
              <el-input v-model="form.channelName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="渠道类型" prop="channelType">
              <el-select v-model="form.channelType" style="width: 100%;" @change="onChannelTypeChange">
                <el-option label="图片" value="image"></el-option>
                <el-option label="视频" value="video"></el-option>
                <el-option label="LLM" value="llm"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务商">
              <el-input v-model="form.provider"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="API Base URL">
              <el-input v-model="form.baseUrl"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="API Key">
              <el-input v-model="form.apiKey" show-password></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="API Secret">
              <el-input v-model="form.apiSecret" show-password></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="支持模型">
              <el-select
                v-model="form.supportedModelsValue"
                multiple
                filterable
                allow-create
                default-first-option
                :placeholder="form.channelType === 'llm' ? '输入模型名，* 表示所有模型' : '选择公开模型编码'"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in channelTypeModelOptions"
                  :key="item.modelCode"
                  :label="getModelOptionLabel(item)"
                  :value="item.modelCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="权重">
              <el-input-number
                v-model="form.weight"
                :min="0"
                :step="1"
                controls-position="right"
                style="width: 100%;"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优先级">
              <el-input-number
                v-model="form.priority"
                :min="0"
                :step="1"
                controls-position="right"
                style="width: 100%;"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="连接超时(ms)">
              <el-input-number v-model="form.connectTimeout" :min="0" :step="1000" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="读取超时(ms)">
              <el-input-number v-model="form.readTimeout" :min="0" :step="1000" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="扩展配置(JSON)">
              <el-input
                type="textarea"
                :rows="2"
                v-model="form.configJson"
                :placeholder="form.channelType === 'llm' ? '{&quot;defaultMaxOutputTokens&quot;:2048,&quot;reserveMultiplier&quot;:1.5,&quot;minReservePoints&quot;:0.01,&quot;minChargePoints&quot;:0.0001}' : '如 {&quot;qualityOptions&quot;:{&quot;low&quot;:{&quot;api_key&quot;:&quot;&quot;},&quot;medium&quot;:{&quot;api_key&quot;:&quot;&quot;},&quot;high&quot;:{&quot;api_key&quot;:&quot;&quot;}}}'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="16">
            <el-form-item label="备注">
              <el-input v-model="form.remark"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="启用">
              <el-switch v-model="form.enabled"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addOrUpdate">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="模型与映射配置" :visible.sync="modelConfigDialogVisible" width="1180px" top="4vh">
      <el-tabs v-model="modelConfigTab" @tab-click="onModelConfigTabClick">
        <el-tab-pane label="模型管理" name="model">
          <div class="tab-toolbar">
            <el-select v-model="modelQuery.channelType" clearable size="small" placeholder="模型类型" style="width: 140px;">
              <el-option label="全部" value=""></el-option>
              <el-option label="图片" value="image"></el-option>
              <el-option label="视频" value="video"></el-option>
            </el-select>
            <el-select v-model="modelQuery.enabled" clearable size="small" placeholder="启用状态" style="width: 140px;">
              <el-option label="启用" :value="true"></el-option>
              <el-option label="禁用" :value="false"></el-option>
            </el-select>
            <el-button size="small" icon="el-icon-refresh" @click="loadModelList">刷新</el-button>
            <el-button size="small" type="primary" icon="el-icon-circle-plus" @click="addModel">新增模型</el-button>
          </div>

          <el-table
            size="mini"
            stripe
            border
            max-height="260"
            :data="displayModelList"
            v-loading="modelListLoading"
          >
            <el-table-column prop="modelCode" label="模型编码" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="modelName" label="展示名称" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="channelType" label="类型" width="80" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="getChannelTypeTag(scope.row.channelType)">
                  {{ getChannelTypeLabel(scope.row.channelType) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="尺寸" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">{{ formatArrayValue(scope.row.supportedSizes) }}</template>
            </el-table-column>
            <el-table-column label="Quality" min-width="140" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.supportsQuality">{{ formatArrayValue(scope.row.qualityOptions) }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="defaultSize" label="默认尺寸" width="90" align="center"></el-table-column>
            <el-table-column prop="defaultQuality" label="默认Quality" width="110" align="center"></el-table-column>
            <el-table-column prop="sort" label="排序" width="70" align="center"></el-table-column>
            <el-table-column label="启用" width="80" align="center">
              <template slot-scope="scope">
                <el-switch :value="!!scope.row.enabled" @change="toggleModelEnabled(scope.row)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="90" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="editModel(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="modelFormVisible" class="inline-editor">
            <div class="inline-editor-title">{{ modelFormTitle }}</div>
            <el-form :model="modelForm" :rules="modelRules" ref="modelForm" label-width="120px" size="small">
              <el-row :gutter="12">
                <el-col :span="8">
                  <el-form-item label="模型编码" prop="modelCode">
                    <el-input v-model="modelForm.modelCode" :disabled="!!modelForm.id" placeholder="如 image_hd"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="展示名称" prop="modelName">
                    <el-input v-model="modelForm.modelName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="类型" prop="channelType">
                    <el-select v-model="modelForm.channelType" style="width: 100%;">
                      <el-option label="图片" value="image"></el-option>
                      <el-option label="视频" value="video"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="12">
                <el-col :span="8">
                  <el-form-item label="支持尺寸">
                    <el-select
                      v-model="modelForm.supportedSizesValue"
                      multiple
                      filterable
                      allow-create
                      default-first-option
                      placeholder="如 1k/2k/4k"
                      style="width: 100%;"
                    >
                      <el-option v-for="item in imageSizeOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="默认尺寸">
                    <el-select v-model="modelForm.defaultSize" clearable filterable allow-create default-first-option style="width: 100%;">
                      <el-option v-for="item in imageSizeOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="支持Quality">
                    <el-switch v-model="modelForm.supportsQuality"></el-switch>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="12" v-if="modelForm.supportsQuality">
                <el-col :span="12">
                  <el-form-item label="Quality选项">
                    <el-select
                      v-model="modelForm.qualityOptionsValue"
                      multiple
                      filterable
                      allow-create
                      default-first-option
                      placeholder="low/medium/high/xhigh/max"
                      style="width: 100%;"
                    >
                      <el-option v-for="item in qualityOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="默认Quality">
                    <el-select v-model="modelForm.defaultQuality" clearable filterable allow-create default-first-option style="width: 100%;">
                      <el-option v-for="item in qualityOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="12">
                <el-col :span="8">
                  <el-form-item label="排序">
                    <el-input-number v-model="modelForm.sort" :min="0" :step="1" style="width: 100%;"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="启用">
                    <el-switch v-model="modelForm.enabled"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="备注">
                    <el-input v-model="modelForm.remark"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="模型描述">
                <el-input type="textarea" :rows="2" v-model="modelForm.description"></el-input>
              </el-form-item>
            </el-form>
            <div class="inline-editor-actions">
              <el-button size="small" @click="modelFormVisible = false">取消</el-button>
              <el-button size="small" type="primary" @click="saveModel">保存模型</el-button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="渠道映射" name="mapping">
          <div class="tab-toolbar">
            <el-select
              v-model="mappingQuery.channelType"
              clearable
              size="small"
              placeholder="渠道类型"
              style="width: 140px;"
              @change="onMappingQueryChannelTypeChange"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="图片" value="image"></el-option>
              <el-option label="视频" value="video"></el-option>
            </el-select>
            <el-select
              v-model="mappingQuery.channelId"
              clearable
              filterable
              size="small"
              placeholder="渠道ID"
              style="width: 180px;"
            >
              <el-option
                v-for="item in mappingQueryChannelOptions"
                :key="item.channelId"
                :label="`${item.channelName || item.channelId} (${item.channelId})`"
                :value="item.channelId"
              ></el-option>
            </el-select>
            <el-select
              v-model="mappingQuery.modelCode"
              clearable
              filterable
              size="small"
              placeholder="公开模型"
              style="width: 200px;"
            >
              <el-option
                v-for="item in mappingQueryModelOptions"
                :key="item.modelCode"
                :label="getModelOptionLabel(item)"
                :value="item.modelCode"
              ></el-option>
            </el-select>
            <el-select v-model="mappingQuery.enabled" clearable size="small" placeholder="启用状态" style="width: 140px;">
              <el-option label="启用" :value="true"></el-option>
              <el-option label="禁用" :value="false"></el-option>
            </el-select>
            <el-button size="small" type="primary" icon="el-icon-search" @click="loadMappingList">搜索</el-button>
            <el-button size="small" icon="el-icon-refresh" @click="loadMappingList">刷新</el-button>
            <el-button size="small" type="primary" icon="el-icon-circle-plus" @click="addMapping">新增映射</el-button>
          </div>

          <el-table
            size="mini"
            stripe
            border
            max-height="260"
            :data="mappingList"
            v-loading="mappingLoading"
          >
            <el-table-column prop="channelId" label="渠道ID" width="120" align="center"></el-table-column>
            <el-table-column prop="channelType" label="类型" width="80" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="getChannelTypeTag(scope.row.channelType)">
                  {{ getChannelTypeLabel(scope.row.channelType) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="modelCode" label="公开模型" min-width="160" show-overflow-tooltip>
              <template slot-scope="scope">{{ formatModelLabel(scope.row.modelCode) }}</template>
            </el-table-column>
            <el-table-column prop="providerModel" label="渠道真实模型" min-width="170" show-overflow-tooltip></el-table-column>
            <el-table-column label="尺寸" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">{{ formatArrayValue(scope.row.supportedSizes, '不限') }}</template>
            </el-table-column>
            <el-table-column label="Quality" min-width="140" show-overflow-tooltip>
              <template slot-scope="scope">{{ formatArrayValue(scope.row.supportedQualities, '不限') }}</template>
            </el-table-column>
            <el-table-column prop="priority" label="优先级" width="80" align="center"></el-table-column>
            <el-table-column label="启用" width="80" align="center">
              <template slot-scope="scope">
                <el-switch :value="!!scope.row.enabled" @change="toggleMappingEnabled(scope.row)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="updateTime" label="更新时间" width="160" align="center"></el-table-column>
            <el-table-column label="操作" width="90" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="editMapping(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="mappingFormVisible" class="inline-editor">
            <div class="inline-editor-title">{{ mappingFormTitle }}</div>
            <el-form :model="mappingForm" :rules="mappingRules" ref="mappingForm" label-width="120px" size="small">
              <el-row :gutter="12">
                <el-col :span="8">
                  <el-form-item label="渠道类型" prop="channelType">
                    <el-select v-model="mappingForm.channelType" style="width: 100%;" @change="onMappingFormChannelTypeChange">
                      <el-option label="图片" value="image"></el-option>
                      <el-option label="视频" value="video"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="渠道ID" prop="channelId">
                    <el-select v-model="mappingForm.channelId" filterable style="width: 100%;">
                      <el-option
                        v-for="item in mappingFormChannelOptions"
                        :key="item.channelId"
                        :label="`${item.channelName || item.channelId} (${item.channelId})`"
                        :value="item.channelId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="公开模型" prop="modelCode">
                    <el-select v-model="mappingForm.modelCode" filterable style="width: 100%;" @change="onMappingModelChange">
                      <el-option
                        v-for="item in mappingFormModelOptions"
                        :key="item.modelCode"
                        :label="getModelOptionLabel(item)"
                        :value="item.modelCode"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="12">
                <el-col :span="8">
                  <el-form-item label="渠道真实模型" prop="providerModel">
                    <el-input v-model="mappingForm.providerModel" placeholder="如 gpt-image-2"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="支持尺寸">
                    <el-select
                      v-model="mappingForm.supportedSizesValue"
                      multiple
                      filterable
                      allow-create
                      default-first-option
                      placeholder="为空表示不限"
                      style="width: 100%;"
                    >
                      <el-option v-for="item in imageSizeOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="支持Quality">
                    <el-select
                      v-model="mappingForm.supportedQualitiesValue"
                      multiple
                      filterable
                      allow-create
                      default-first-option
                      placeholder="为空表示不限"
                      style="width: 100%;"
                    >
                      <el-option v-for="item in qualityOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="12">
                <el-col :span="12">
                  <el-form-item label="质量映射(JSON)">
                    <el-input type="textarea" :rows="2" v-model="mappingForm.qualityMapping" placeholder='如 {"low":"standard"}'></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="额外配置(JSON)">
                    <el-input type="textarea" :rows="2" v-model="mappingForm.configJson" placeholder='如 {"key":"value"}'></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="12">
                <el-col :span="8">
                  <el-form-item label="优先级">
                    <el-input-number v-model="mappingForm.priority" :min="0" :step="1" style="width: 100%;"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="启用">
                    <el-switch v-model="mappingForm.enabled"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="备注">
                    <el-input v-model="mappingForm.remark"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="inline-editor-actions">
              <el-button size="small" @click="mappingFormVisible = false">取消</el-button>
              <el-button size="small" type="primary" @click="saveMapping">保存映射</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="modelConfigDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>

<script>
import {
  addChannelConfig,
  addGenerationModel,
  addGenerationModelMapping,
  getChannelConfigList,
  getGenerationModelList,
  getGenerationModelMappingList,
  refreshChannelConfigCache,
  updateChannelConfig,
  updateGenerationModel,
  updateGenerationModelMapping
} from '@/api/merchant/service/channel'

export default {
  name: 'serviceChannelConfig',
  data () {
    return {
      list: [],
      listLoading: false,
      dialogFormVisible: false,
      dialogStatus: '新增渠道',
      modelConfigDialogVisible: false,
      modelConfigTab: 'model',
      listQuery: {
        channelType: '',
        keyword: ''
      },
      form: this.getDefaultForm(),
      modelList: [],
      modelListLoading: false,
      modelQuery: {
        channelType: '',
        enabled: ''
      },
      modelFormVisible: false,
      modelFormTitle: '新增模型',
      modelForm: this.getDefaultModelForm(),
      allChannelList: [],
      mappingList: [],
      mappingLoading: false,
      mappingQuery: {
        channelType: '',
        channelId: '',
        modelCode: '',
        enabled: ''
      },
      mappingFormVisible: false,
      mappingFormTitle: '新增映射',
      mappingForm: this.getDefaultMappingForm(),
      imageSizeOptions: ['1k', '2k', '4k'],
      qualityOptions: ['low', 'medium', 'high', 'xhigh', 'max'],
      rules: {
        channelId: [
          { required: true, message: '请输入渠道ID', trigger: 'blur' }
        ],
        channelName: [
          { required: true, message: '请输入渠道名称', trigger: 'blur' }
        ],
        channelType: [
          { required: true, message: '请选择渠道类型', trigger: 'change' }
        ]
      },
      modelRules: {
        modelCode: [
          { required: true, message: '请输入模型编码', trigger: 'blur' }
        ],
        modelName: [
          { required: true, message: '请输入展示名称', trigger: 'blur' }
        ],
        channelType: [
          { required: true, message: '请选择模型类型', trigger: 'change' }
        ]
      },
      mappingRules: {
        channelType: [
          { required: true, message: '请选择渠道类型', trigger: 'change' }
        ],
        channelId: [
          { required: true, message: '请选择渠道ID', trigger: 'change' }
        ],
        modelCode: [
          { required: true, message: '请选择公开模型', trigger: 'change' }
        ],
        providerModel: [
          { required: true, message: '请输入渠道真实模型', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    displayList () {
      const keyword = (this.listQuery.keyword || '').trim().toLowerCase()
      return this.list.filter(item => {
        if (this.listQuery.channelType && item.channelType !== this.listQuery.channelType) {
          return false
        }
        if (!keyword) {
          return true
        }
        const text = `${item.channelId || ''} ${item.channelName || ''}`.toLowerCase()
        return text.indexOf(keyword) > -1
      })
    },
    displayModelList () {
      return this.modelList.filter(item => {
        if (this.modelQuery.channelType && item.channelType !== this.modelQuery.channelType) {
          return false
        }
        if (this.modelQuery.enabled !== '' && item.enabled !== this.modelQuery.enabled) {
          return false
        }
        return true
      })
    },
    channelTypeModelOptions () {
      return this.modelList.filter(item => item.channelType === this.form.channelType)
    },
    mappingQueryModelOptions () {
      if (!this.mappingQuery.channelType) {
        return this.modelList
      }
      return this.modelList.filter(item => item.channelType === this.mappingQuery.channelType)
    },
    mappingQueryChannelOptions () {
      if (!this.mappingQuery.channelType) {
        return this.allChannelList
      }
      return this.allChannelList.filter(item => item.channelType === this.mappingQuery.channelType)
    },
    mappingFormModelOptions () {
      return this.modelList.filter(item => item.channelType === this.mappingForm.channelType)
    },
    mappingFormChannelOptions () {
      return this.allChannelList.filter(item => item.channelType === this.mappingForm.channelType)
    }
  },
  created () {
    this.getSearch()
    this.loadModelList()
  },
  methods: {
    getDefaultForm () {
      return {
        id: null,
        channelId: '',
        channelName: '',
        channelType: 'image',
        provider: '',
        apiKey: '',
        apiSecret: '',
        baseUrl: '',
        supportedModelsValue: [],
        configJson: '',
        enabled: true,
        weight: 100,
        priority: 1,
        connectTimeout: 30000,
        readTimeout: 300000,
        remark: ''
      }
    },
    getDefaultModelForm () {
      return {
        id: null,
        modelCode: '',
        modelName: '',
        channelType: 'image',
        description: '',
        supportedSizesValue: [],
        supportsQuality: false,
        qualityOptionsValue: [],
        defaultSize: '',
        defaultQuality: '',
        enabled: true,
        sort: 100,
        remark: ''
      }
    },
    getDefaultMappingForm () {
      return {
        id: null,
        modelCode: '',
        channelType: 'image',
        channelId: '',
        providerModel: '',
        supportedSizesValue: [],
        supportedQualitiesValue: [],
        qualityMapping: '',
        configJson: '',
        enabled: true,
        priority: 100,
        remark: ''
      }
    },
    normalizeList (res) {
      if (Array.isArray(res)) {
        return res
      }
      if (res && Array.isArray(res.records)) {
        return res.records
      }
      if (res && Array.isArray(res.list)) {
        return res.list
      }
      return []
    },
    parseArrayValue (value) {
      if (!value) {
        return []
      }
      if (Array.isArray(value)) {
        return value.map(item => `${item}`.trim()).filter(item => item)
      }
      const raw = `${value}`.trim()
      if (!raw) {
        return []
      }
      if (raw.charAt(0) === '[') {
        try {
          const arr = JSON.parse(raw)
          return Array.isArray(arr) ? arr.map(item => `${item}`.trim()).filter(item => item) : []
        } catch (e) {
          return []
        }
      }
      return raw.split(/[\n,]/).map(item => item.trim()).filter(item => item)
    },
    normalizeArray (value, lowerCase) {
      const result = []
      this.parseArrayValue(value).forEach(item => {
        const normalized = lowerCase ? item.toLowerCase() : item
        if (normalized && result.indexOf(normalized) === -1) {
          result.push(normalized)
        }
      })
      return result
    },
    buildArrayJson (value, lowerCase) {
      const arr = this.normalizeArray(value, lowerCase)
      return arr.length ? JSON.stringify(arr) : ''
    },
    normalizeJsonText (value, message) {
      const raw = value === null || value === undefined ? '' : `${value}`.trim()
      if (!raw) {
        return ''
      }
      try {
        return JSON.stringify(JSON.parse(raw))
      } catch (e) {
        throw new Error(message)
      }
    },
    toNumber (value, defaultValue) {
      const n = Number(value)
      return Number.isNaN(n) ? defaultValue : n
    },
    formatArrayValue (value, emptyText) {
      const arr = this.parseArrayValue(value)
      return arr.length ? arr.join(', ') : (emptyText || '-')
    },
    getModelOptionLabel (model) {
      if (!model) {
        return ''
      }
      return `${model.modelName || model.modelCode} (${model.modelCode})`
    },
    getChannelTypeLabel (type) {
      if (type === 'video') {
        return '视频'
      }
      if (type === 'llm') {
        return 'LLM'
      }
      return '图片'
    },
    getChannelTypeTag (type) {
      if (type === 'video') {
        return 'warning'
      }
      if (type === 'llm') {
        return 'primary'
      }
      return 'success'
    },
    formatModelLabel (modelCode) {
      if (!modelCode) {
        return '-'
      }
      const code = `${modelCode}`
      const model = this.modelList.find(item => item.modelCode === code)
      return model ? `${model.modelName || code} (${code})` : code
    },
    formatSupportedModels (models) {
      const arr = this.parseArrayValue(models)
      return arr.length ? arr.map(code => this.formatModelLabel(code)).join(', ') : ''
    },
    getSearch () {
      this.listLoading = true
      getChannelConfigList({
        channelType: this.listQuery.channelType,
        keyword: this.listQuery.keyword
      }).then(res => {
        this.list = this.normalizeList(res)
      }).finally(() => {
        this.listLoading = false
      })
    },
    loadModelList () {
      this.modelListLoading = true
      getGenerationModelList({}).then(res => {
        this.modelList = this.normalizeList(res)
      }).finally(() => {
        this.modelListLoading = false
      })
    },
    loadChannelOptions (channelType) {
      return getChannelConfigList({
        channelType: channelType || ''
      }).then(res => {
        this.allChannelList = this.normalizeList(res)
      })
    },
    loadMappingList () {
      this.mappingLoading = true
      getGenerationModelMappingList({
        channelType: this.mappingQuery.channelType,
        channelId: this.mappingQuery.channelId,
        modelCode: this.mappingQuery.modelCode,
        enabled: this.mappingQuery.enabled
      }).then(res => {
        this.mappingList = this.normalizeList(res)
      }).finally(() => {
        this.mappingLoading = false
      })
    },
    addCard () {
      this.dialogStatus = '新增渠道'
      this.form = this.getDefaultForm()
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    editCard (row) {
      this.dialogStatus = '编辑渠道'
      this.form = {
        id: row.id,
        channelId: row.channelId || '',
        channelName: row.channelName || '',
        channelType: row.channelType || 'image',
        provider: row.provider || '',
        apiKey: row.apiKey || '',
        apiSecret: row.apiSecret || '',
        baseUrl: row.baseUrl || '',
        supportedModelsValue: this.parseArrayValue(row.supportedModels),
        configJson: row.configJson || '',
        enabled: !!row.enabled,
        weight: this.toNumber(row.weight, 100),
        priority: this.toNumber(row.priority, 1),
        connectTimeout: this.toNumber(row.connectTimeout, 30000),
        readTimeout: this.toNumber(row.readTimeout, 300000),
        remark: row.remark || ''
      }
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    onChannelTypeChange (type) {
      this.form.supportedModelsValue = this.form.supportedModelsValue.filter(code => {
        const model = this.modelList.find(item => item.modelCode === code)
        return !model || model.channelType === type
      })
      if (type === 'llm') {
        if (!this.form.provider) {
          this.form.provider = 'openai'
        }
        if (!this.form.baseUrl) {
          this.form.baseUrl = 'https://api.openai.com'
        }
        if (!this.form.supportedModelsValue.length) {
          this.form.supportedModelsValue = ['*']
        }
        if (!this.form.configJson) {
          this.form.configJson = JSON.stringify({
            defaultMaxOutputTokens: 2048,
            reserveMultiplier: 1.5,
            minReservePoints: 0.01,
            minChargePoints: 0.0001
          })
        }
      }
    },
    buildSupportedModels () {
      return this.buildArrayJson(this.form.supportedModelsValue, true)
    },
    addOrUpdate () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }
        let configJson = ''
        try {
          configJson = this.normalizeJsonText(this.form.configJson, '扩展配置不是合法JSON')
        } catch (e) {
          this.$message.error(e.message)
          return
        }

        const payload = {
          id: this.form.id,
          channelId: this.form.channelId,
          channelName: this.form.channelName,
          channelType: this.form.channelType,
          provider: this.form.provider,
          apiKey: this.form.apiKey,
          apiSecret: this.form.apiSecret,
          baseUrl: this.form.baseUrl,
          supportedModels: this.buildSupportedModels(),
          configJson: configJson,
          enabled: this.form.enabled,
          weight: this.form.weight,
          priority: this.form.priority,
          connectTimeout: this.form.connectTimeout,
          readTimeout: this.form.readTimeout,
          remark: this.form.remark
        }

        const request = payload.id ? updateChannelConfig(payload) : addChannelConfig(payload)
        request.then(() => {
          this.$message.success(payload.id ? '更新成功' : '新增成功')
          this.dialogFormVisible = false
          this.getSearch()
        })
      })
    },
    openModelConfigDialog (tab) {
      this.modelConfigDialogVisible = true
      this.modelConfigTab = tab || 'model'
      this.modelFormVisible = false
      this.mappingFormVisible = false
      this.loadModelList()
      this.loadChannelOptions(this.mappingQuery.channelType).then(() => {
        if (this.modelConfigTab === 'mapping') {
          this.loadMappingList()
        }
      })
    },
    onModelConfigTabClick () {
      if (this.modelConfigTab === 'model') {
        this.loadModelList()
        return
      }
      this.loadChannelOptions(this.mappingQuery.channelType).then(() => {
        this.loadMappingList()
      })
    },
    addModel () {
      this.modelFormTitle = '新增模型'
      this.modelForm = this.getDefaultModelForm()
      this.modelForm.channelType = this.modelQuery.channelType || 'image'
      this.modelFormVisible = true
      this.$nextTick(() => {
        this.$refs.modelForm && this.$refs.modelForm.clearValidate()
      })
    },
    editModel (row) {
      this.modelFormTitle = '编辑模型'
      this.modelForm = {
        id: row.id,
        modelCode: row.modelCode || '',
        modelName: row.modelName || '',
        channelType: row.channelType || 'image',
        description: row.description || '',
        supportedSizesValue: this.parseArrayValue(row.supportedSizes),
        supportsQuality: !!row.supportsQuality,
        qualityOptionsValue: this.parseArrayValue(row.qualityOptions),
        defaultSize: row.defaultSize || '',
        defaultQuality: row.defaultQuality || '',
        enabled: !!row.enabled,
        sort: this.toNumber(row.sort, 100),
        remark: row.remark || ''
      }
      this.modelFormVisible = true
      this.$nextTick(() => {
        this.$refs.modelForm && this.$refs.modelForm.clearValidate()
      })
    },
    buildModelPayload (source) {
      return {
        id: source.id,
        modelCode: (source.modelCode || '').trim().toLowerCase(),
        modelName: (source.modelName || '').trim(),
        channelType: (source.channelType || '').trim().toLowerCase(),
        description: (source.description || '').trim(),
        supportedSizes: this.buildArrayJson(source.supportedSizesValue, true),
        supportsQuality: !!source.supportsQuality,
        qualityOptions: source.supportsQuality ? this.buildArrayJson(source.qualityOptionsValue, true) : '',
        defaultSize: (source.defaultSize || '').trim().toLowerCase(),
        defaultQuality: source.supportsQuality ? (source.defaultQuality || '').trim().toLowerCase() : '',
        enabled: !!source.enabled,
        sort: this.toNumber(source.sort, 100),
        remark: (source.remark || '').trim()
      }
    },
    saveModel () {
      this.$refs.modelForm.validate(valid => {
        if (!valid) {
          return
        }
        const payload = this.buildModelPayload(this.modelForm)
        const request = payload.id ? updateGenerationModel(payload) : addGenerationModel(payload)
        request.then(() => {
          this.$message.success(payload.id ? '模型已更新' : '模型已新增')
          this.modelFormVisible = false
          this.loadModelList()
        })
      })
    },
    toggleModelEnabled (row) {
      const payload = this.buildModelPayload({
        id: row.id,
        modelCode: row.modelCode,
        modelName: row.modelName,
        channelType: row.channelType,
        description: row.description,
        supportedSizesValue: this.parseArrayValue(row.supportedSizes),
        supportsQuality: !!row.supportsQuality,
        qualityOptionsValue: this.parseArrayValue(row.qualityOptions),
        defaultSize: row.defaultSize,
        defaultQuality: row.defaultQuality,
        enabled: !row.enabled,
        sort: row.sort,
        remark: row.remark
      })
      updateGenerationModel(payload).then(() => {
        this.$message.success(payload.enabled ? '模型已启用' : '模型已禁用')
        this.loadModelList()
      })
    },
    onMappingQueryChannelTypeChange (channelType) {
      this.mappingQuery.channelId = ''
      this.mappingQuery.modelCode = ''
      this.loadChannelOptions(channelType)
    },
    addMapping () {
      this.mappingFormTitle = '新增映射'
      this.mappingForm = this.getDefaultMappingForm()
      this.mappingForm.channelType = this.mappingQuery.channelType || 'image'
      this.mappingForm.channelId = this.mappingQuery.channelId || ''
      this.mappingFormVisible = true
      this.loadChannelOptions(this.mappingForm.channelType)
      this.$nextTick(() => {
        this.$refs.mappingForm && this.$refs.mappingForm.clearValidate()
      })
    },
    editMapping (row) {
      this.mappingFormTitle = '编辑映射'
      this.mappingForm = {
        id: row.id,
        modelCode: row.modelCode || '',
        channelType: row.channelType || 'image',
        channelId: row.channelId || '',
        providerModel: row.providerModel || '',
        supportedSizesValue: this.parseArrayValue(row.supportedSizes),
        supportedQualitiesValue: this.parseArrayValue(row.supportedQualities),
        qualityMapping: row.qualityMapping || '',
        configJson: row.configJson || '',
        enabled: !!row.enabled,
        priority: this.toNumber(row.priority, 100),
        remark: row.remark || ''
      }
      this.mappingFormVisible = true
      this.loadChannelOptions(this.mappingForm.channelType)
      this.$nextTick(() => {
        this.$refs.mappingForm && this.$refs.mappingForm.clearValidate()
      })
    },
    onMappingFormChannelTypeChange (channelType) {
      this.mappingForm.channelId = ''
      this.mappingForm.modelCode = ''
      this.loadChannelOptions(channelType)
    },
    onMappingModelChange (modelCode) {
      const model = this.modelList.find(item => item.modelCode === modelCode)
      if (!model) {
        return
      }
      if (!this.mappingForm.supportedSizesValue.length) {
        this.mappingForm.supportedSizesValue = this.parseArrayValue(model.supportedSizes)
      }
      if (model.supportsQuality && !this.mappingForm.supportedQualitiesValue.length) {
        this.mappingForm.supportedQualitiesValue = this.parseArrayValue(model.qualityOptions)
      }
    },
    buildMappingPayload (source) {
      return {
        id: source.id,
        modelCode: (source.modelCode || '').trim().toLowerCase(),
        channelType: (source.channelType || '').trim().toLowerCase(),
        channelId: (source.channelId || '').trim(),
        providerModel: (source.providerModel || '').trim(),
        supportedSizes: this.buildArrayJson(source.supportedSizesValue, true),
        supportedQualities: this.buildArrayJson(source.supportedQualitiesValue, true),
        qualityMapping: this.normalizeJsonText(source.qualityMapping, '质量映射不是合法JSON'),
        configJson: this.normalizeJsonText(source.configJson, '额外配置不是合法JSON'),
        enabled: !!source.enabled,
        priority: this.toNumber(source.priority, 100),
        remark: (source.remark || '').trim()
      }
    },
    saveMapping () {
      this.$refs.mappingForm.validate(valid => {
        if (!valid) {
          return
        }
        let payload
        try {
          payload = this.buildMappingPayload(this.mappingForm)
        } catch (e) {
          this.$message.error(e.message)
          return
        }
        const request = payload.id ? updateGenerationModelMapping(payload) : addGenerationModelMapping(payload)
        request.then(() => {
          this.$message.success(payload.id ? '映射已更新' : '映射已新增')
          this.mappingFormVisible = false
          this.loadMappingList()
        })
      })
    },
    toggleMappingEnabled (row) {
      let payload
      try {
        payload = this.buildMappingPayload({
          id: row.id,
          modelCode: row.modelCode,
          channelType: row.channelType,
          channelId: row.channelId,
          providerModel: row.providerModel,
          supportedSizesValue: this.parseArrayValue(row.supportedSizes),
          supportedQualitiesValue: this.parseArrayValue(row.supportedQualities),
          qualityMapping: row.qualityMapping,
          configJson: row.configJson,
          enabled: !row.enabled,
          priority: row.priority,
          remark: row.remark
        })
      } catch (e) {
        this.$message.error(e.message)
        return
      }
      updateGenerationModelMapping(payload).then(() => {
        this.$message.success(payload.enabled ? '映射已启用' : '映射已禁用')
        this.loadMappingList()
      })
    },
    toggleEnabled (row) {
      const payload = {
        id: row.id,
        channelId: row.channelId,
        channelName: row.channelName,
        channelType: row.channelType,
        provider: row.provider,
        apiKey: row.apiKey,
        apiSecret: row.apiSecret,
        baseUrl: row.baseUrl,
        supportedModels: row.supportedModels,
        configJson: row.configJson,
        enabled: !row.enabled,
        weight: row.weight,
        priority: row.priority,
        connectTimeout: row.connectTimeout,
        readTimeout: row.readTimeout,
        remark: row.remark
      }
      updateChannelConfig(payload).then(() => {
        this.$message.success(payload.enabled ? '已启用' : '已禁用')
        this.getSearch()
      })
    },
    refreshCache () {
      refreshChannelConfigCache().then(() => {
        this.$message.success('渠道配置缓存已刷新')
        this.getSearch()
      })
    }
  }
}
</script>

<style scoped>
.tab-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.inline-editor {
  margin-top: 14px;
  padding: 14px 14px 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
}

.inline-editor-title {
  margin-bottom: 12px;
  font-weight: 700;
  color: #303133;
}

.inline-editor-actions {
  text-align: right;
}
</style>
